import Vue from 'vue';
import Router from 'vue-router';
import LoginComponent from './components/Login.vue';
import DefaultComponent from './components/Default.vue';
import Application from './components/formio/Applications.vue'
import Form from './components/formio/Forms.vue'
import FormBuilder from './components/formio/FormBuilder.vue'
import FormPreview from './components/formio/FormPreview.vue'
import PublishedForm from './components/formio/PublishedForm.vue'
import Settings from './components/formio/Settings.vue'
import store from './store/index';
import NoAccess from './components/NoAccess.vue';

Vue.use(Router);


let isRedirected = false;

async function ifNotAuthenticated(to, from, next) {
  if (!store.getters['login/getIsUserAuthenticated']) {
    if (!isRedirected) {
      sessionStorage.setItem('redirectUrl', window.location.pathname);
    } else {
      sessionStorage.removeItem('redirectUrl');
    }
    next();
    return;
  }
  next('/');
}

async function ifAuthenticated(to, from, next) {
  if (store.getters['login/getIsUserAuthenticated']) {
    const redirectUrl = sessionStorage.getItem('redirectUrl');
    if (!isRedirected && redirectUrl !== null && redirectUrl !== '/' && redirectUrl !== '/login') {
      sessionStorage.removeItem('redirectUrl');
      isRedirected = true;
      next(redirectUrl);
    } else {
      next();
    }
    return;
  }
  next('/login');
}

function checkAuthorization(to, from, next) {
    const requiredRole = to.meta.requiredRole;
    if (to.meta && to.meta.requiredRole) {
        const roles = store.getters['login/getUserRoles'];
        //check if the user has required role
        let userRoles = roles.filter(r => r == requiredRole);
        if (userRoles.length == 1) {
            //if user has the required role
            next()
        } else {
            //if user doesn't have the required role then
            //navigate to home page
            next('errorpage');
        }
    } else {
        next();
    }
}

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/login',
            name: 'login',
            component: LoginComponent,
            beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/',
            component: DefaultComponent,
            beforeEnter: ifAuthenticated,
            children: [
                {
                    name: 'dashboard',
                    path: '',
                    component: Application,
                    //beforeEnter: checkAuthorization,
                    //meta: {
                    //    requiredRole: 'GLOBALADMIN'
                    //},
                },
                {
                    name: 'applications',
                    path: 'applications',
                    component: Application,
                    //beforeEnter: checkAuthorization,
                    // meta: {
                    //    requiredRole: 'GLOBALADMIN'
                    // },
                },
                {
                    name: 'forms',
                    path: 'forms',
                    component: Form,
                    //beforeEnter: checkAuthorization,
                    // meta: {
                    //    requiredRole: 'GLOBALADMIN'
                    // },
                },
                {
                    name: 'formbuilder',
                    path: 'formbuilder/:formid',
                    component: FormBuilder,
                    //beforeEnter: checkAuthorization,
                    // meta: {
                    //    requiredRole: 'GLOBALADMIN'
                    // },
                },
                {
                    name: 'formpreview',
                    path: 'formpreview/:formid',
                    component: FormPreview,
                    //beforeEnter: checkAuthorization,
                    // meta: {
                    //    requiredRole: 'GLOBALADMIN'
                    // },
                },
                {
                    name: 'formpreview',
                    path: 'form/:applicationid/:formid',
                    component: PublishedForm,
                    //beforeEnter: checkAuthorization,
                    // meta: {
                    //    requiredRole: 'GLOBALADMIN'
                    // },
                },
                {
                    name: 'settings',
                    path: 'settings',
                    component: Settings,
                    beforeEnter: checkAuthorization,
                },
                {
                    name: 'noaccess',
                    path: 'noaccess',
                    component: NoAccess,
                    beforeEnter: checkAuthorization,
                },
                {
                    path: '*',
                    component: () => import('./views/404.vue')
                }
            ]
        }
    ]
});

// router.beforeEach(async (to, from, next) => {
//     await store.dispatch('login/acquireTokenSilent');
//     const isAuthenticated = store.getters['login/getIsUserAuthenticated'];
//     const loggedUser = store.getters["login/getUser"];
//     const isSuperAdmin = loggedUser.isSuperAdmin;
//     // console.log(isSuperAdmin);

//     if (to.name !== 'login' && !isAuthenticated) {
//         next('/login');
//         localStorage.setItem("currentUrl", JSON.stringify(to));
//     }
//     else if (to.name == 'settings' && isAuthenticated && !isSuperAdmin) {
//         next('/noaccess')
//     }
//     else {
//         next();
//     }
// });

export default router;
